export const environment = {
  production: !0,
  console: false,
  API_URL: "https://apipre.apiacpos.com/2_16_0_bridge/api/",  
  CODIGO_APLICACION: "CUSTOMAN",
  ID_APLICACION: "19",
  chClaveEmpresa: "ALJAFERIA",
  TICKETS_URL: "https://tickamore.webventa.iacpospre.com/aljaferia",
  chProyectoOnLine: "VENTAONLINE",
  chEntornoConexion: "PREPRODUCCION",
  chNombreProyecto: "CUSTOMMAN",
  chOrigenConexion: "CUSTOMMAN",
  NUMSERIE: "CUSTO$A$SZ45$A$MMAN$A$23g!.",
  API_MICROSERVICIOS: "https://apipre.apiacpos.com/WebAPICoreBridge_1_8_0",
  VALIDATE_PERMISSIONS: true,
  API_TOKEN_USER: "admin@admin.com", 
  API_TOKEN_PASSWORD: "IACPOS.2023a+"   
};
